import { baseURL } from "../utilits/config";
import axios from "axios";

export function getclicks(callback) {
  const config = {
    method: "get",
    url: baseURL + "/add-click-count",
    headers: {},
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}
